import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard"; // Import the CopyToClipboard component
import { ToastContainer, toast } from 'react-toastify'; // Import Toast components
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles

import Search from "../assets/images/search-image.png";
import EditIcon from "../assets/icons/edit.svg";
import ShareIcon from "../assets/icons/share.svg";
import DeleteIcon from "../assets/icons/delete.svg";
import CopyIcon from "../assets/icons/copy.svg"; // Make sure you have the CopyIcon image
import MapComponent from "./MapComponent";
import CheckIcon from "../assets/icons/checked.svg"; // Add a checkmark or "copied" icon
import OfficeIcon from '../assets/icons/OfficeList.svg'
import BussinessIcon from '../assets/icons/Bussiness.svg'
import OtherIcon from '../assets/icons/OtherList.svg'
import HomeIcon from '../assets/icons/HomeLIst.svg'
import {
  EmailShareButton,
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share"; // Import specific share buttons
import { EmailIcon, WhatsappIcon, FacebookIcon, TwitterIcon } from "react-share"; // Import the share icons
import { log } from "console";
interface Address {
  id: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  pinCode: string;
  blockCode: string;
  pamCode: string;
  latitude: number;
  longitude: number;
  addressType: string;
  isDeleteRequestSubmitted: boolean;
}

const AddressDetails = () => {
  const [showResults, setShowResults] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // State for delete modal
  const { id } = useParams<{ id: string }>(); // Get the address ID from the URL

  const [address, setAddress] = useState<Address | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [deleteReason, setDeleteReason] = useState(""); // State for delete reason input
  const [isPamCodeFocused, setIsPamCodeFocused] = useState(false); // Track if pamCode is focused
  const [copied, setCopied] = useState(false); // Track the copied status
  const [showShareOptions, setShowShareOptions] = useState(false); // State for showing share options
  const [addressToDelete, setAddressToDelete] = useState(""); // Store address to be deleted
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [copiedPamCode, setCopiedPamCode] = useState<string | null>(null); // State to track copied pamCode

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchAddressDetails(id);
    }
  }, [id]);

  useEffect(() => {
    setIsFormChanged(deleteReason.trim().length > 0);
  }, [deleteReason]);

  const handleSearchClick = () => {
    setShowResults(true);
  };

  const fetchAddressDetails = async (id: string) => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error('Token not found in localStorage');
      setErrorMessage('Session expired. Please log in again.');
      navigate('/'); // Redirect to login page
      return; // Stop execution if token is not found
    }

    try {
      const response = await fetch(`https://pamsapi.vofoxsolutions.com/api/Address/ViewAddedAddressByIdAsync?id=${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`, // Include the Authorization header
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      const data: Address[] = await response.json(); // Expecting an array of addresses
      if (data.length > 0) {
        setAddress(data[0]); // Use the first address object from the array
      } else {
        setErrorMessage("No address found.");
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("An error occurred while fetching address details.");
    }
  };

  const handleEdit = () => {
    navigate(`/edit-address/${id}`);
  };

  const handleShareClick = () => {
    setShowShareOptions(!showShareOptions); // Toggle the share options
  };
  const handleDelete = (addressId: string) => {
    setShowDeleteModal(true);
    setAddressToDelete(addressId);
    setDeleteReason('');
  };
  const handleDeleteSubmit = async () => {
    const id = addressToDelete;
    if (!id) {
      toast.error('Address ID is missing. Please try again.');
      return;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      console.error('Token not found in localStorage');
      setErrorMessage('Session expired. Please log in again.');
      navigate('/');
      return;
    }

    try {
      const response = await fetch("https://pamsapi.vofoxsolutions.com/api/address/RequestDeleteAddressAsync", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`, // Include the Authorization header
        },
        body: JSON.stringify({
          addressId: parseInt(id), // Send the address ID
          deleteReason: deleteReason, // Send the delete reason
        }),
      });

      if (!response.ok) throw new Error("Failed to send delete request");

      setShowDeleteModal(false); // Close the delete modal after submission
      setDeleteReason(''); // Clear the delete reason after successful submission
      setAddressToDelete(''); // Clear the address to delete
      setTimeout(() => {
        setSuccessMessage(""); // Hide success message after a few seconds
        navigate("/home");
      }, 3000); // Redirect to home after 3 seconds
    } catch (error) {
      console.error(error);
      setErrorMessage("An error occurred while sending the delete request.");
    }
  };

  const handleCopy = async (pamCode: string) => {
    if (!pamCode) return; // Ensure no empty value is copied
    try {
      await navigator.clipboard.writeText(pamCode);
      setCopiedPamCode(pamCode);
      setTimeout(() => setCopiedPamCode(null), 2000); // Reset copied state after 2 seconds
      // toast.success('PAM code copied!'); // Uncomment if using toast notifications
    } catch (err) {
      console.error('Failed to copy:', err);
      // toast.error('Failed to copy!'); // Uncomment if using toast notifications
    }
  };


  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteReason(''); // Clear the delete reason when modal is closed
    setAddressToDelete(''); // Clear the address to delete
  };

  const shareMessage = `Check out this address:\n${address?.addressLine1}, ${address?.addressLine2}, ${address?.addressLine3}\nPincode: ${address?.pinCode}\nPAM Code: ${address?.pamCode}\naddressType: ${address?.addressType}\n\nMore details: https://getmethere.in`;

  return (
    <div className="container mx-auto p-6"> <ToastContainer />
      {/* Search Section */}
      {/* <div className="w-full bg-indigo-100 p-6 rounded-md shadow-sm flex items-center relative">
        <div className="w-full sm:w-1/2">
          <h3 className="text-lg sm:text-xl text-gray-800 font-semibold mb-2">
            Quickly Find Addresses – Search Here!
          </h3>
          <div className="relative bg-white rounded-md flex items-center">
            <input
              type="text"
              placeholder="Search address here..."
              className="flex-grow pl-4 pr-2 py-2 rounded-md focus:outline-none border-none placeholder-gray-500"
            />
            <button
              className="flex items-center px-4 py-2 bg-blue-600 text-white text-sm rounded-r-md"
              onClick={handleSearchClick}
            >
              <svg
                className="w-5 h-5 mr-2"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Search
            </button>
          </div>
          {showResults && (
            <div className="inline-grid grid-cols-2 rounded-lg bg-white shadow-shadow1 w-auto mt-4">
              <a className="px-3 py-3 text-blue bg-blue bg-opacity-20 rounded-md flex items-center" href="#">
                <i className="pam-map text-sm md:text-lg"></i>
                <span className="mx-3 text-blue text-sm md:text-base">View on Map</span>
              </a>
              <a className="px-3 py-3 text-casper rounded-md flex items-center" href="#">
                <i className="pam-grid text-sm md:text-lg"></i>
                <span className="mx-3 text-dark text-sm md:text-base">View as grid</span>
              </a>
            </div>
          )}
        </div>
        <div className="hidden lg:block absolute right-0 bottom-0">
          <img src={Search} alt="Illustration" className="h-32" />
        </div>
      </div> */}

      {/* Map Section */}
      <div className="w-full mt-6 bg-white rounded-md shadow-md p-6">
        <div className="relative h-[500px]">
          {address ? (
            <MapComponent addresses={[address]} />
          ) : (
            <p>Loading map...</p> // Or any loading placeholder
          )}
        </div>
        {successMessage && <p className="text-green-500">{successMessage}</p>}
        {address ? (
          <div className="flex flex-col items-center">
            <div className="w-full p-4 bg-white rounded-lg relative">
              {/* Address Details */}
              <div className="flex  text-lg font-bold gap-2 mb-4">
                {address.addressType.toLowerCase() === 'office' && (
                  <>
                    <img src={OfficeIcon} alt="Office Icon" className="w-10 h-10 mr-2" /> Office
                  </>
                )}
                {/* {address.addressType.toLowerCase() === 'business' && (
                  <>
                    <img src={BussinessIcon} alt="Business Icon" className="w-6 h-6 mr-2" /> Business
                  </>
                )} */}
                {address.addressType.toLowerCase() === 'home' && (
                  <>
                    <img src={HomeIcon} alt="Home Icon" className="w-10 h-10 mr-2" /> Home
                  </>
                )}
                {address.addressType.toLowerCase() === 'other' && (
                  <>
                    <img src={OtherIcon} alt="Other Icon" className="w-10 h-10 mr-2" /> Other
                  </>
                )}
                {!['office',  'home', 'other'].includes(address.addressType.toLowerCase()) && (
                  <>
                    <img src={OtherIcon} alt="Custom Type Icon" className="w-10 h-10 mr-1" /> {address.addressType}
                  </>
                )}
              </div>
              <p className="text-lg">Building/House: {address.addressLine1}</p>
              <p className="text-lg">Street: {address.addressLine2}</p>
              <p className="text-lg">City: {address.addressLine3}</p>
              <p className="text-lg">Pincode: {address.pinCode}</p>

              {/* <p className="text-lg">Block Code: {address.blockCode}</p> */}
              {/* <p className="text-lg">Coordinates: {address.latitude}, {address.longitude}</p> */}
              {/* PAM Code with CopyToClipboard */}
              <div className="flex items-center gap-4">
                <label htmlFor="pamCode" className="text-lg font-medium">
                  PAM Code:
                </label>
                <div className="relative" style={{ width: "250px" }}> {/* Adjust width as needed */}
                  <input
                    id="pamCode"
                    type="text"
                    value={address?.pamCode || ""}
                    className="text-lg p-2 pr-10 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                    readOnly
                  />
                  {/* Copy Icon inside the text box */}
                  <button
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-blue-500"
                    aria-label="Copy PAM Code"
                    onClick={() => handleCopy(address?.pamCode || "")}
                  >
                    {copiedPamCode === address?.pamCode ? (
                      <img src={CheckIcon} alt="Copied" className="w-6 h-6" />
                    ) : (
                      <img src={CopyIcon} alt="Copy" className="w-6 h-6" />
                    )}
                  </button>
                </div>
                {copied && <span className="text-sm text-green-500">Copied!</span>}
              </div>



              {/* Action Icons */}
              <div className="absolute bottom-5 right-20 flex gap-4">
                <button
                  onClick={handleEdit}
                  className="w-[90px] h-[40px] flex items-center justify-center p-[10px_18px] border border-gray-200 bg-white rounded-md hover:bg-[#c4d4fc] focus:outline-none"
                >
                  <img src={EditIcon} alt="Edit" className="w-8 h-6" />
                </button>
                <button
                  onClick={handleShareClick}
                  className="w-[90px] h-[40px] flex items-center justify-center p-[10px_18px] border  border-gray-200 bg-white rounded-md hover:bg-[#c4d4fc] focus:outline-none"
                >
                  <img src={ShareIcon} alt="Share" className="w-8 h-6" />
                </button>

                <button
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent navigating to AddressDetails

                    if (address.isDeleteRequestSubmitted) {
                      if (!toast.isActive("delete-request")) {
                      toast.info("Delete request already submitted for this address." , {toastId: "delete-request"});
                      }
                    } else {
                      handleDelete(address.id); // Proceed with delete request
                    }
                  }}
                  title="Delete"
                  className="w-[90px] h-[40px] flex items-center justify-center p-[10px_18px] border  border-gray-200 bg-white rounded-md hover:bg-[#c4d4fc] focus:outline-none"
                >
                  <img src={DeleteIcon} alt="Delete" className="w-8 h-6" />
                </button>



              </div>




            </div>
            {showShareOptions && (
              <div className="flex gap-4 ml-auto mr-[8rem]">


                <EmailShareButton
                  url={shareMessage}
                  className="transform transition-transform duration-300 hover:scale-150 hover:shadow-3xl"
                >
                  <EmailIcon
                    size={32}
                    round
                    style={{
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 10px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                </EmailShareButton>

                <WhatsappShareButton
                  url={shareMessage}
                  className="transform transition-transform duration-300 hover:scale-150 hover:shadow-3xl"
                >
                  <WhatsappIcon
                    size={32}
                    round
                    style={{
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 10px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                </WhatsappShareButton>

                <FacebookShareButton
                  url={shareMessage}
                  className="transform transition-transform duration-300 hover:scale-150 hover:shadow-3xl"
                >
                  <FacebookIcon
                    size={32}
                    round
                    style={{
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 10px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                </FacebookShareButton>

                <TwitterShareButton
                  url={shareMessage}
                  className="transform transition-transform duration-300 hover:scale-150 hover:shadow-3xl"
                >
                  <TwitterIcon
                    size={32}
                    round
                    style={{
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 10px 15px rgba(0, 0, 0, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                </TwitterShareButton>
              </div>
            )}


          </div>

        ) : (
          <p className="text-gray-500">Loading...</p>
        )}
      </div>



      {/* Address Details Section */}
      {/* <div className="container max-w-screen-lg mx-auto p-6">        {errorMessage && <p className="text-red-500">{errorMessage}</p>} */}

      {/* Delete Modal */}
      {showDeleteModal && (
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-[1000]"
        >
          <div className="bg-white p-6 rounded-lg shadow-lg w-1/2">
            <h2 className="text-xl font-bold mb-4">Delete Address</h2>
            <p>Are you sure you want to delete this address?</p>
            <textarea
              className="w-full mt-4 p-2 border border-gray-300 rounded-md"
              placeholder="Enter delete reason..."
              value={deleteReason}
              onChange={(e) => setDeleteReason(e.target.value)}
            />
            <div className="mt-4 flex justify-between">
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                onClick={handleCloseDeleteModal}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 text-white rounded-md ${isFormChanged
                  ? 'bg-blue-600 hover:bg-blue-700'
                  : 'bg-gray-400 cursor-not-allowed'
                  }`}
                onClick={handleDeleteSubmit}
                disabled={!isFormChanged}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      <footer className="w-full mt-20">
        <div className="px-6 py-6 bg-white shadow-shadow1 rounded-md">
          <p className="text-center text-jetgrey text-sm">
          GET ME THERE. © 2024
          </p>
        </div>
      </footer>
    </div>
  );
};

// Add this skeleton loader component
const AddressDetailsSkeleton = () => (
  <div className="w-full bg-white rounded-md shadow-md p-6 animate-pulse">
    {/* Map Skeleton */}
    <div className="relative h-[500px] bg-gray-200 rounded-lg mb-6"></div>

    {/* Address Details Skeleton */}
    <div className="flex flex-col items-center">
      <div className="w-full p-4 bg-white rounded-lg relative">
        {/* Address Type */}
        <div className="flex items-center mb-4">
          <div className="w-6 h-6 bg-gray-200 rounded-full mr-2"></div>
          <div className="h-4 w-24 bg-gray-200 rounded"></div>
        </div>

        {/* Address Lines */}
        <div className="space-y-3 mb-4">
          <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
          <div className="h-4 w-2/3 bg-gray-200 rounded"></div>
          <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
        </div>

        {/* PAM Code */}
        <div className="flex items-center gap-4 mb-4">
          <div className="h-4 w-20 bg-gray-200 rounded"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>

        {/* Action Buttons */}
        <div className="absolute bottom-5 right-20 flex gap-4">
          <div className="w-[90px] h-[40px] bg-gray-200 rounded-md"></div>
          <div className="w-[90px] h-[40px] bg-gray-200 rounded-md"></div>
          <div className="w-[90px] h-[40px] bg-gray-200 rounded-md"></div>
        </div>
      </div>
    </div>
  </div>
);

export default AddressDetails;
